import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import {STORAGE_TOKEN_NAME} from "@intelingu/core/constants/base.constants";
import {config} from "config";

export class GraphqlClient {

    client: ApolloClient<any>;

    async initialize() {
        const httpLink = createHttpLink({
            uri: `${config.backendBase}/graphql`,
        });

        const authLink = setContext((_, { headers }) => {
            // get the authentication token from local storage if it exists
            const token = localStorage.getItem(STORAGE_TOKEN_NAME);
            // return the headers to the context so httpLink can read them
            return {
                headers: {
                    ...headers,
                    'X-IG-Auth-Token': token,
                }
            }
        });

        this.client = new ApolloClient({
            link: authLink.concat(httpLink),
            cache: new InMemoryCache()
        });
    }

}

export const graphql = new GraphqlClient();
